import { RangeSlider, RangeSliderFilledTrack, RangeSliderThumb, RangeSliderTrack } from "@chakra-ui/react";

type Props = { min: number; max: number; defaultValue: number[]; onChange: (newValues: number[]) => void; labelsEveryXStep: number; step: number; }
export default function RangePicker({ min, max, defaultValue, onChange, labelsEveryXStep, step }: Props) {
    return (
        <RangeSlider
            aria-label={['min', 'max']}
            colorScheme='brand'
            step={step}
            onChange={(values) => {
                onChange([values[0], values[1]]);
            }}
            defaultValue={defaultValue}
            max={max}
            min={min}
        >
            <RangeSliderTrack>
                <RangeSliderFilledTrack />
            </RangeSliderTrack>
            <RangeSliderThumb index={0} />
            <RangeSliderThumb index={1} />
        </RangeSlider>
    )
}
